import FormControl from '@mui/material/FormControl';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import Checkbox from '@mui/material/Checkbox';
import Input from '@mui/material/Input';
import Grid from '@mui/material/Grid';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableBody';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import {  toast } from 'react-toastify';
import '../../assets/style/style.css';
import { useMaterialUIController, setOrderContext } from "context";
import CircularProgress from '@mui/material/CircularProgress';
import { useParams, useNavigate } from 'react-router-dom';
import Config from "../../config.js";
import { useEffect, useState } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";
import productNoImage from "../../assets/images/no-image.png";
import { handleErrors } from "common.js";
import { TextField } from '@mui/material';
import FormHelperText from '@mui/material/FormHelperText';
function FulfillmentAction(props) {
  const [controller, dispatch] = useMaterialUIController();
  const { orderContext }       = controller;  
  const { orderID, orderNumber } =  props;  
  const navigate   = useNavigate();
  const { t }     = useTranslation();
  const baseUrl  = Config.baseUrl;
  const bearerToken = `Bearer ${localStorage.getItem('JWTToken')}`;
  const [isLoading, setIsLoading] = useState(false);
  const [shipmentSubmitIsLoading, setShipmentSubmitIsLoading] = useState(false);
  const [dataTableData, setDataTableData] = useState({});
  const [openFulfillmentModel, setOpenFulfillmentModel] = useState(orderContext.fulfillmentModelOpen);
  const [fulfillQuantity, setFulfillQuantity] = useState({});
  const [itemSelect, setItemSelect] = useState({});
  const [shipmentWeight, setShipmentWeight] = useState("");
  const [shipmentWidth, setShipmentWidth] = useState("");
  const [shipmentHeight, setShipmentHeight] = useState("");
  const [shipmentLength, setShipmentLength] = useState("");
  const [fulfillmentDetails, setFulfillmentDetails] = useState({});
  const [shipmentWeightError, setShipmentWeightError] = useState(false);
  const [shipmentWeightHelperText, setShipmentWeightHelperText] = useState('');
  const [shipmentWidthError, setShipmentWidthError] = useState(false);
  const [shipmentWidthHelperText, setShipmentWidthHelperText] = useState('');
  const [shipmentHeightError, setShipmentHeightError] = useState(false);
  const [shipmentHeightHelperText, setShipmentHeightHelperText] = useState('');
  const [shipmentLengthError, setShipmentLengthError] = useState(false);
  const [shipmentLengthHelperText, setShipmentLengthHelperText] = useState('');

  const handleChangeShipmentLength = (event) => {
    setShipmentLength(event.target.value);
    setShipmentLengthError(false);
    setShipmentLengthHelperText('');
  };
           
  const handleChangeShipmentWeight = (event) => {
    setShipmentWeight(event.target.value);
    setShipmentWeightError(false);
    setShipmentWeightHelperText('');
  };

  const handleChangeShipmentWidth = (event) => {
    setShipmentWidth(event.target.value);
    setShipmentWidthError(false);
    setShipmentWidthHelperText('');
  };

  const handleChangeShipmentHeight = (event) => {
    setShipmentHeight(event.target.value);
    setShipmentHeightError(false);
    setShipmentHeightHelperText('');
  };
    

  useEffect(() => {
    loadItemsToFulfill();
  }, []);

  const handleItemSelectChange = (index) => {
    setItemSelect((prevChecked) => ({
      ...prevChecked,
      [index]: !prevChecked[index],
    }));
  };

  const handleFulfillQuantityChange = (index, value) => {
    setFulfillQuantity((prevQuantities) => ({
      ...prevQuantities,
      [index]: value,
    }));
  };


  const handleShipmentSubmit = () => {
    
    let shipmentItems = {};
    let i             = 0;

    for (const key in itemSelect) 
    { 
        const value = itemSelect[key];
        if(value)
        {
            shipmentItems[key]           = fulfillmentDetails[key];
            shipmentItems[key].toFulfill = fulfillQuantity[key];
            i++;
        }     
    };

    if(i === 0)
    {
      toast.error(t("Please select items to fulfill"));
      return;
    }

    for (const key in shipmentItems) 
    { 
        const value = shipmentItems[key].toFulfill;

        if(!(value > 0) || fulfillQuantity[key] > value)
        {
            toast.error(t("Please enter valid fulfillment quantity"));
            return;
        }     
    };

    let shipmentItemsTemp = {};    
    for (const key in shipmentItems) 
    { 
        shipmentItemsTemp[shipmentItems[key].orderItemID] = shipmentItems[key];
    };

    if(!(parseFloat(shipmentWeight) > 0))
    {
        setShipmentWeightError(true);
        setShipmentWeightHelperText(t("Please enter the shipment weight"));
        return;
    }

    if(!(parseFloat(shipmentLength) > 0))
    {
        setShipmentLengthError(true);
        setShipmentLengthHelperText(t("Please enter the shipment length"));
        return;
    }

    if(!(parseFloat(shipmentWidth) > 0))
    {
        setShipmentWidthError(true);
        setShipmentWidthHelperText(t("Please enter the shipment width"));
        return;
    }

    if(!(parseFloat(shipmentHeight) > 0))
    {
        setShipmentHeightError(true);
        setShipmentHeightHelperText(t("Please enter the shipment height"));
        return;
    }    

    let requestPayLoad = { 
      orderID: orderID, 
      shipmentItems: shipmentItemsTemp,
      shipmentLength: parseFloat(shipmentLength),
      shipmentWeight: parseFloat(shipmentWeight),
      shipmentWidth: parseFloat(shipmentWidth),
      shipmentHeight: parseFloat(shipmentHeight),
    };

    setShipmentSubmitIsLoading(true);
    axios({      
          url     : baseUrl+"/order/saveItemShipment",
          data    : requestPayLoad,
          method  : "POST",
          headers : {
            Authorization   : bearerToken,
            function        : Config.FUNCTION_KEY
          },        
        }).then(function (response) 
        {
            const responseData           = response.data;
            const responseDataStatusCode = responseData.status ? responseData.status : 0;
            const responseMessage        = responseData.message ? responseData.message : '';
            const responseStatusCode     = response.status;

            if(responseStatusCode === 200)
            {
                setShipmentSubmitIsLoading(false);       

                (responseDataStatusCode === 1) ? toast.success(t(responseMessage)) : toast.error(t(responseMessage));
                    
                if(responseDataStatusCode === 1 && responseData && responseData.data)
                {
                    const unfulfilledColumns  =  [
                      { label: `${t("Product ID")}`, field: "productId" },
                      { label: `${t("Image")}`, field: "image" },
                      { label: `${t("Product Name")}`, field: "title" },
                      { label: `${t("Unit Price")}`, field: "price" },
                      { label: `${t("Sku")}`,field: "sku" },
                      { label: `${t("Qty")}`, field: "quantity" },
                      { label: `${t("Qty Fulfilled")}`, field: "fulfilledQuantity" },
                      { label: `${t("Avl. Qty For Fulfill")}`, field: "quantityForFulfill" },
                      { label: `${t("Total")}`, field: "total" },
                    ];


                    const fulfilledColumns  =  [
                      { label: `${t("Product ID")}`, field: "productId" },
                      { label: `${t("Image")}`, field: "image" },
                      { label: `${t("Product Name")}`, field: "title" },
                      { label: `${t("Unit Price")}`, field: "price" },
                      { label: `${t("Sku")}`,field: "sku" },
                      { label: `${t("Qty Fulfilled")}`, field: "fulfilledQuantity" },
                      { label: `${t("Shipment Status")}`, field: "shipmentStatus" },
                    ];

                    var unfulfilledRows          = [];
                    var unfulfilledProductsCount = 0; 
                    var allItemsFulfilled        = true;
                    var orderFulfillmentStatus   = 'unfulfilled';
                    var partiallyFulfilledFlag   = false;

                    responseData.data.orderItemList.map((item, index) => {

                      let productImage      = item.productImage ? item.productImage : productNoImage;
                          unfulfilledProductsCount  = (item.fulfillmentStatus === 'unfulfilled') ? unfulfilledProductsCount+1 : unfulfilledProductsCount;
                          
                          if(allItemsFulfilled)
                          allItemsFulfilled = (item.fulfillmentStatus === 'unfulfilled' || item.fulfillmentStatus === 'partially_fulfilled') ? false : true;

                      var tempData = {
                        "productId"  : "#"+item.vendorProductId,
                        "image"      : <Box className="productImageBox"><img className="productImage" src={productImage} alt={item.title}  /></Box>,
                        "title"      : <Box className="productTitleBox" title={item.title}>{item.title}</Box>,
                        "price"      : `₹${item.price.toFixed(2)}`,
                        "sku"        : item.sku ? item.sku : '-',
                        "quantity"   : item.quantity,
                        "fulfilledQuantity"   : item.fulfillableQuantity,
                        "quantityForFulfill" : (item.quantity - item.fulfillableQuantity),
                        "total"               : `₹${(item.price * item.quantity).toFixed(2)}`,
                      };
                      
                      
                      unfulfilledRows.push(tempData);
                  });

                    var fulfillmentRowsList = [];
                    var fulfillmentItems    = responseData.data.fulfillmentDetails;
                    fulfillmentItems.map((item, index) => {

                      var fulfilledRows = [];
                      item.fulfilledItems.map((items, itemIndex) => {
                        
                      let productImage           = items.productImage ? items.productImage : productNoImage;
                          partiallyFulfilledFlag = true;

                      var tempData = {
                        "productId"  : "#"+items.vendorProductId,
                        "image"      : <Box className="productImageBox"><img className="productImage" src={productImage} alt={items.title}  /></Box>,
                        "title"      : <Box className="productTitleBox" title={items.title}>{items.title}</Box>,
                        "price"      : `₹${items.price.toFixed(2)}`,
                        "sku"        : items.sku ? items.sku : '-',
                        "fulfilledQuantity" : items.fulfilledQuantity,
                        "shipmentStatus" : item.shipmentStatus ?? "Manifested",
                      };
                      
                      fulfilledRows.push(tempData);

                      });

                      fulfillmentRowsList.push(fulfilledRows);
                  });

                  orderFulfillmentStatus   = allItemsFulfilled ? 'fulfilled' : partiallyFulfilledFlag ? 'partially_fulfilled' : 'unfulfilled';
                  
                  setOrderContext(dispatch, { ...orderContext, 
                    unfulfilledTableData: { unfulfilledColumns, unfulfilledRows, unfulfilledProductsCount: unfulfilledProductsCount, totalOrderedProducts: responseData.data.totalOrderedProducts },
                    fulfilledTableData: { fulfilledColumns, fulfillmentRowsList, fulfillmentItems },
                    fulfillmentModelOpen: false,
                    orderDetails: { ...orderContext.orderDetails, orderStatus: orderFulfillmentStatus, allItemsFulfilled: allItemsFulfilled },
                  }); 
                }
                else 
                {
                  setOrderContext(dispatch, { ...orderContext, 
                    fulfillmentModelOpen: false,
                  });  
                }                
            }        
            else 
            {
              toast.error(t('An unexpected error occurred while communicating with server'));
              return;            
            }   
        }).catch(function (error) {
          handleErrors(error, t, navigate);
        });
  }
  
  const handleOrderFulfillmentModelClose = () => {
    setOrderContext(dispatch, { ...orderContext, 
      fulfillmentModelOpen: false,
    });  
  }

  const loadItemsToFulfill = () => {
    setIsLoading(true);
    axios({      
          url     : baseUrl+"/order/itemsToFulfill/"+orderID,
          method  : "GET",
          headers : {
            Authorization   : bearerToken,
            function        : Config.FUNCTION_KEY
          },        
        }).then(function (response) 
        {
            const responseData           = response.data;
            const responseDataStatusCode = responseData.status;
            const responseMessage        = responseData.message;
            const responseStatusCode     = response.status;

            if(responseStatusCode === 200)
            {
                setIsLoading(false);
                if(responseDataStatusCode === 0)
                {
                    if(responseMessage)
                    toast.error(t(responseMessage));
                    
                    const redirectTimeout = setTimeout(() => {          
                      clearTimeout(redirectTimeout);          
                      window.location.href = "/order/details/"+orderID;          
                    }, 1000);
                }
                else if(responseDataStatusCode === 1 && responseData && responseData.data)
                {
                    const columns = [
                      { field: 'itemSelect', label: '' },
                      { field: 'productId', label: `${t("Product ID")}` },
                      { field: 'image', label: `${t("Image")}` },
                      { field: 'title', label: `${t("Product Name")}` },
                      { field: 'price', label: `${t("Unit Price")}` },
                      { field: 'sku', label: `${t("Sku")}` },
                      { field: 'quantity', label: `${t("Qty")}` },
                      { field: 'fulfilledQuantity', label: `${t("Qty Fulfilled")}` },
                      { field: 'quantityToFulfill', label: `${t("Qty To Fulfill")}` },
                    ];
                                     
                    var fulfillQuantityTemp = {};     
                    var itemSelectTemp      = {}; 
                    var fulfillObject       = {};
                    var rows                = [];

                    responseData.data.map((item, index) => {

                      let toFulfill        = item.quantity - item.fulfillableQuantity;                      
                      fulfillObject[index] = { 
                                                orderItemID: item.orderItemID, 
                                                toFulfill: toFulfill,
                                                orderLineItemID: item.orderLineItemID, 
                                             }; 

                      fulfillQuantityTemp[index] = toFulfill;
                      itemSelectTemp[index]      = false;

                      let productImage = item.productImage ? item.productImage : productNoImage;
                      let tempData     = {
                          "itemSelect" : '',                                          
                          "productId"  : "#"+item.vendorProductId,
                          "image"      : <Box className="productImageBox"><img className="productImage" src={productImage} alt={item.title}  /></Box>,
                          "title"      : <Box className="productTitleBox" title={item.title}>{item.title}</Box>,
                          "price"      : `₹${item.price.toFixed(2)}`,
                          "sku"        : item.sku ? item.sku : '-',
                          "quantity"   : item.quantity,
                          "fulfilledQuantity" : item.fulfillableQuantity,
                          "quantityToFulfill" : toFulfill,
                        };
                 
                        rows.push(tempData);
                    });

                    setItemSelect(itemSelectTemp);                        
                    setFulfillQuantity(fulfillQuantityTemp);
                    setFulfillmentDetails(fulfillObject);
                    setDataTableData({ columns, rows });  
                }
            }        
            else 
            {
              toast.error(t('An unexpected error occurred while communicating with server'));
              return;            
            }   
        }).catch(function (error) {
          handleErrors(error, t, navigate);
        });
  }

  const fulfillmentModelLoad = () => {
    return (
        <Dialog open={openFulfillmentModel} onClose={handleOrderFulfillmentModelClose}
          sx={{
            '& .MuiDialog-paper': {
              width: '90%', 
              maxWidth: 'none', 
            },
          }}
        >
          <DialogTitle id="sync-orders-dialog" onClose={handleOrderFulfillmentModelClose}>
            {t("Fulfillments Of Order")+" "+orderNumber}  
          </DialogTitle>         
          <DialogContent dividers>
            {isLoading ?       
              <Box className='circularLoadingModelOuter'>   
                <CircularProgress size={30} className='circularLoadingModel' />
              </Box>
            : <></>}

            {dataTableData.columns && dataTableData.columns.length > 0 ?
              <TableContainer>
                <Table>
                  <TableHead key={1}>
                    <TableRow key={1}> 
                      {dataTableData.columns.map((column, index) => (
                        <TableCell key={"key-"+index}>{column.label}</TableCell>
                      ))}
                    </TableRow>
                  </TableHead> 
                  <TableBody key={2}>
                  {dataTableData.rows.map((row, index) => (
                    <TableRow key={index}>
                      {dataTableData.columns.map((column) => (
                        <TableCell key={column.field+'-'+index}>   
                            {column.field === 'quantityToFulfill' ? (
                              <FormControl sx={{ margin: '10px 0px', minWidth: 50, }}>
                                <Input
                                  variant = "outlined"  
                                  type="number"
                                  value={fulfillQuantity[index]}
                                  onChange={(e) => { 
                                    const newValue = e.target.value;
                                    const min = 1; 
                                    const max = row[column.field]; 
                                    if (newValue >= min && newValue <= max)
                                    handleFulfillQuantityChange(index, e.target.value); 
                                  }}
                                  inputProps={{
                                    min: 1,
                                    max: row[column.field],
                                  }}
                                  sx={{
                                    border: '1px solid #CCCCCC',
                                    borderRadius: '4px',
                                    padding: '4px 8px',
                                  }}                              
                                />
                              </FormControl>
                            ) : 
                            <>   
                            {column.field === 'itemSelect' ? (
                              <FormControl sx={{ margin: '10px 0px', minWidth: 50, }}>
                                <Checkbox
                                  checked={itemSelect[index]}
                                  onChange={(e) => { handleItemSelectChange(index)}}
                                />
                              </FormControl>
                            ) :                          
                            <>{row[column.field]}</>  }
                            </>}
                        </TableCell>
                      ))}
                    </TableRow>
                  ))}
                  </TableBody>     
                </Table>
              </TableContainer>
            : <></>}

            <Grid container spacing={2} my={1}>
                <Grid item sm={3} xs={12}>
                    <FormControl sx={{ margin: '10px 0px', width: '100%' }}>
                      <TextField 
                        type = "number"
                        label = {t('Weight (Grams)')}
                        variant = "outlined" 
                        value = {shipmentWeight}
                        inputProps={{
                          min: 0,
                        }}
                        onChange={handleChangeShipmentWeight}
                        error={shipmentWeightError}
                        required
                      />
                      <FormHelperText sx={{ position: 'absolute', bottom: -20, right: 0, color: 'red' }}>
                        {shipmentWeightHelperText}
                      </FormHelperText>
                    </FormControl>
                </Grid>
                <Grid item sm={3} xs={12}>
                    <FormControl sx={{ margin: '10px 0px', width: '100%' }}>
                      <TextField 
                        type = "number"
                        label = {t('Shipment Length (CM)')}
                        variant = "outlined" 
                        value = {shipmentLength}
                        inputProps={{
                          min: 0,
                        }}
                        onChange={handleChangeShipmentLength}   
                        error={shipmentLengthError}
                        required
                      />
                      <FormHelperText sx={{ position: 'absolute', bottom: -20, right: 0, color: 'red' }}>
                        {shipmentLengthHelperText}
                      </FormHelperText>
                    </FormControl>
                </Grid>
                <Grid item sm={3} xs={12}>
                    <FormControl sx={{ margin: '10px 0px', width: '100%' }}>
                      <TextField 
                        type = "number"
                        label = {t('Shipment Width (CM)')}
                        variant = "outlined" 
                        value = {shipmentWidth}
                        inputProps={{
                          min: 0,
                        }}
                        onChange={handleChangeShipmentWidth}   
                        error={shipmentWidthError}
                        required
                      />
                      <FormHelperText sx={{ position: 'absolute', bottom: -20, right: 0, color: 'red' }}>
                        {shipmentWidthHelperText}
                      </FormHelperText>
                    </FormControl>
                </Grid>
                <Grid item sm={3} xs={12}>
                    <FormControl sx={{ margin: '10px 0px', width: '100%' }}>
                      <TextField 
                        type = "number"
                        label = {t('Shipment Height (CM)')}
                        variant = "outlined" 
                        value = {shipmentHeight}
                        inputProps={{
                          min: 0,
                        }}
                        onChange={handleChangeShipmentHeight} 
                        error={shipmentHeightError}
                        required
                      />
                      <FormHelperText sx={{ position: 'absolute', bottom: -20, right: 0, color: 'red' }}>
                        {shipmentHeightHelperText}
                      </FormHelperText>
                    </FormControl>
                </Grid>
              </Grid>  
              
          <Container className="buttonContainer">
            <Box>
              <Button key={"button-1"}                    
                variant="contained" 
                sx={{color : '#FFFFFF', height : 45, margin: '10px'}} 
                onClick={handleShipmentSubmit}
                disabled={shipmentSubmitIsLoading}
                disableRipple
                >
                {t("Submit")}                    
              </Button>
              <Button key={"button-2"}                        
                variant="contained" 
                sx={{color : '#FFFFFF', height : 45, margin: '10px'}} 
                onClick={handleOrderFulfillmentModelClose}
                disabled={shipmentSubmitIsLoading}
                disableRipple
                >
                {t("close")}                    
              </Button>

              {shipmentSubmitIsLoading ?       
              <Box className='circularLoadingModelOuter'>   
                <CircularProgress size={30} className='circularLoadingModel' />
              </Box>
            : <></>}
            </Box>
        </Container>
      </DialogContent>
    </Dialog>  
    );
  }

  return (
          <>
          {fulfillmentModelLoad()}
          </>
         );
}
export default FulfillmentAction;